import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { FALLBACK, SupportedLang, SUPPORTED } from "./languages";
import { persistLanguage, resolveInitialLanguage } from "./language-source";

// Resolved synchronously so the very first paint is already in the right
// language. i18next-browser-languagedetector is deliberately not used: its
// detection order duplicates language-source, and two systems deciding the
// language is what made the previous behaviour hard to reason about.
const initialLanguage = resolveInitialLanguage();

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: FALLBACK,
    supportedLngs: [...SUPPORTED],
    debug: process.env.NODE_ENV === "development",
    interpolation: { escapeValue: false },
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
  });

applyDocumentLanguage(initialLanguage);

function applyDocumentLanguage(lang: SupportedLang) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lang;
  }
}

/** The single way the app changes language, whatever triggered it. */
export function setLanguage(lang: SupportedLang): void {
  if (i18n.language === lang) return;

  i18n.changeLanguage(lang);
  persistLanguage(lang);
  applyDocumentLanguage(lang);
}

export default i18n;
